export default __webpack_public_path__ + "static/media/react.e2ca089d.PNG";